import React, { useEffect, useState } from 'react';
import { Dropdown, Tag, Space } from 'antd';
import { UserOutlined, TeamOutlined, DownOutlined, PlusOutlined } from '@ant-design/icons';
import api from '../../services/api';
import { resolveActiveTeam, setActiveTeamId } from '../../utils/activeTeam';

// Switcher de contexto: Jogador vs Dono de time-comunidade.
// Mesma conta (community_player), so muda a visao/menu. Mostra sempre que
// player logado — se ele nao tem time-comunidade, oferece "Cadastrar time".
export default function ContextSwitcher({ mode }) {
  const [teams, setTeams] = useState([]);
  useEffect(() => {
    let alive = true;
    api.get('/community/team-owner/my').then(r => {
      if (alive) setTeams(r.data?.teams || []);
    }).catch(() => {});
    return () => { alive = false; };
  }, []);

  // Time ativo via helper (URL → localStorage → primeiro)
  const activeTeam = resolveActiveTeam(teams);

  const goPlayer = () => { window.location.href = '/player/dashboard'; };
  const goTeam = (id) => {
    setActiveTeamId(id);
    // Preserva rota atual quando faz sentido:
    // - Se URL tem /time/{action}/:id → substitui so o id (jogos, dashboard,
    //   editar, upgrade)
    // - Se URL tem /time/{path-simples} (mapa, procurar, convites, feed,
    //   amistosos, meus-amistosos) → reload da mesma tela; helper reload
    //   respeita active_team_id novo
    // - Senao → dashboard do time
    const path = window.location.pathname;
    const withIdMatch = path.match(/^(\/time\/(?:dashboard|editar|upgrade|jogos))\/\d+/);
    if (withIdMatch) {
      window.location.href = `${withIdMatch[1]}/${id}`;
      return;
    }
    if (/^\/time\/[a-z-]+$/.test(path)) {
      window.location.reload();
      return;
    }
    window.location.href = `/time/dashboard/${id}`;
  };
  const goCreate = () => { window.location.href = '/time/setup'; };

  const items = [
    {
      key: 'player',
      icon: <UserOutlined />,
      label: (
        <Space><span>Modo Jogador</span>{mode === 'player' && <Tag color="green" style={{ margin: 0 }}>atual</Tag>}</Space>
      ),
      onClick: goPlayer,
    },
    ...teams.map(t => ({
      key: `team-${t.id}`,
      icon: <TeamOutlined />,
      label: (
        <Space>
          <span>Dono: {t.name}</span>
          {/* Tag 'atual' so no time que realmente esta ativo agora,
              nao em todos os times quando mode='team-owner'. */}
          {mode === 'team-owner' && t.id === activeTeam?.id && (
            <Tag color="green" style={{ margin: 0 }}>atual</Tag>
          )}
        </Space>
      ),
      onClick: () => goTeam(t.id),
    })),
    { type: 'divider' },
    {
      key: 'create',
      icon: <PlusOutlined />,
      label: teams.length === 0 ? 'Cadastrar meu time na comunidade' : 'Cadastrar outro time',
      onClick: goCreate,
    },
  ];

  const label = mode === 'team-owner'
    ? (activeTeam ? `Dono: ${activeTeam.name}` : 'Modo Time')
    : 'Modo Jogador';

  return (
    <Dropdown menu={{ items }} trigger={['click']} placement="bottomLeft"
      overlayStyle={{ zIndex: 10050 }}>
      <button
        type="button"
        style={{
          display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer',
          background: mode === 'team-owner' ? 'rgba(37, 211, 102, 0.12)' : '#f6f6f6',
          border: mode === 'team-owner' ? '1px solid #b7eb8f' : '1px solid #e8e8e8',
          padding: '6px 10px', borderRadius: 8, fontSize: 12, fontWeight: 600,
          color: mode === 'team-owner' ? '#128C7E' : '#555',
          maxWidth: 220, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
        }}
      >
        {mode === 'team-owner' ? <TeamOutlined /> : <UserOutlined />}
        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{label}</span>
        <DownOutlined style={{ fontSize: 9 }} />
      </button>
    </Dropdown>
  );
}
